export const SIDEBAR_WIDTH = 290;
export const COLLAPSED_SIDEBAR_WIDTH = 75;

export const IS_DEV = false;
